export default __webpack_public_path__ + "static/media/jeans12.56869ead.jpeg";